import * as React from 'reactn';
import {
    ArrayUtil,
    BaseIcon,
    ComponentFactory,
    dialog, DialogUtil,
    IBaseDialogProps,
    SelectItem
} from "oca-lib-web";
import GraphSettingsDialog from "./GraphDataDialog";
import {createRef} from "react";
import AnalyticsTypes from "../util/AnalyticsTypes";
import GraphUtil from "../util/GraphUtil";
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory,
    dialogs:Array<any>,
    //pageSettings?:PageSettings
    dataSourceOptions:Array<any>,
}

/* Main dialog for selection different graphs */
class PageSettingsDialog extends React.Component<IBaseDialogProps, IState> {

    public alertDialog = createRef<any>();
    public graphSettingsDialog = createRef<any>();

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, props.param);
        console.log("prop params");
        console.log(props.param);

        let dialogs = [
            <GraphSettingsDialog {...componentFactory.renderDialogProps("Graph Data", "Save", this.graphSettingsDialogCallback.bind(this), this.graphSettingsDialog, "md")} />
        ];

        this.state = {
            componentFactory:componentFactory,
            dialogs:dialogs,
            //pageSettings: props.param ? props.param : {},
            dataSourceOptions: []
        };
        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    componentDidMount() {
        let dataSourceOptions = [];
        let dataSources = this.global.customdata.data;
        for (let dataSource of dataSources) {
            dataSourceOptions.push(SelectItem.create(dataSource.id, dataSource.name));
        }
        //let pageId = CacheSettings.getCurrentPage();
        //let currentPage = GraphUtil.getAnalyticsPage(pageId, this.state.analyticsSettings);
        this.setState({dataSourceOptions:dataSourceOptions});
    }

    async handleSave(callback:any) {
        //console.log("handleSave");
        //console.log(this.state.pageSettings);
        let binding = this.state.componentFactory.getDefaultBinding();
        console.log(binding.item)
        callback(binding.item);
    }

    /*handleChanged(value:any, key:string) {
        //let pageSettings = this.state.pageSettings;
        let item = this.state.componentFactory.getDefaultBinding().item;
        item[key] = value;
        this.state.componentFactory
        this.setState({pageSettings:pageSettings});
    }*/

    graphSettingsDialogCallback(graphSettings:GraphSettings) {
        console.log("graphSettingsDialogCallback");

        /*let analyticsSettings = this.state.analyticsSettings;
        let pageId = CacheSettings.getCurrentPage();
        for (let page of analyticsSettings.pages) {
            if (page.id == pageId) {
                page.graphs.push(graphSettings);
            }
        }*/
        //let pageSettings = this.state.pageSettings;
        let pageSettings = this.state.componentFactory.getDefaultBinding().item;
        console.log(pageSettings);
        let found = false;
        for (let i = 0; i<pageSettings.graphs.length; i++) {
            if (pageSettings.graphs[i].id == graphSettings.id) {
                pageSettings.graphs[i] = graphSettings;
                found = true;
            }
        }
        if (!found) {
            console.log("not found")
            pageSettings.graphs.push(graphSettings);
        }

        console.log(pageSettings);

        this.state.componentFactory.addDefaultBinding(null, null, pageSettings);
        this.forceUpdate();

        /*this.setState({pageSettings:pageSettings}, function(this:PageSettingsDialog) {
            this.forceUpdate();
        }.bind(this));*/

        //LocalCache.saveLocal(this.state.selectedProject.id + "_" + Constants.CACHE_ANALYTICS_SETTINGS, JSON.stringify(this.state.analyticsSettings));

        //let analyticsDatasets = this.generateDatasets(this.state.selectedProject.id);
        //this.setState({analyticsDatasets: analyticsDatasets});
        //this.forceUpdate();
    }

    /*getGraphs():Array<GraphSettings> {
        /*let analyticsSettings = this.state.analyticsSettings;
        let pageId = CacheSettings.getCurrentPage();
        for (let page of analyticsSettings.pages) {
            if (page.id == pageId) {
                return page.graphs;
            }
        }
        return null;
        //return GraphUtil.getCurrentAnalyticsPage().graphs;
    }*/

    async deleteGraphSetting(item:any) {
        /*let analyticsSettings = this.state.analyticsSettings;
        let pageId = CacheSettings.getCurrentPage();
        for (let page of analyticsSettings.pages) {
            if (page.id == pageId) {
                ArrayUtils.deleteItemByKey(item, "id", page.graphs);
                console.log(page);
                console.log(page.graphs);
                console.log(analyticsSettings);
            }
        }*/
        let pageSettings = this.state.componentFactory.getDefaultBinding().item;
        ArrayUtil.deleteItem(item, pageSettings.graphs);

        this.state.componentFactory.addDefaultBinding(null, null, pageSettings);
        this.forceUpdate();

        /*this.setState({pageSettings:pageSettings}, function(this:PageSettingsDialog) {
            this.forceUpdate();
        }.bind(this));*/
    }

    moveGraph(item:GraphSettings, direction:string) {
        //let analyticsSettings = this.state.analyticsSettings;
        //let pageId = CacheSettings.getCurrentPage();

        //let pageSettings = this.state.pageSettings;
        let pageSettings = this.state.componentFactory.getDefaultBinding().item;

        let indexOf = pageSettings.graphs.indexOf(item);
        if ((indexOf == 0 && direction == "up") || (indexOf == pageSettings.graphs.length - 1 && direction == "down")) {
            return;
        }

        indexOf = direction == "up" ? indexOf - 1 : indexOf + 1;
        ArrayUtil.deleteItem(item, pageSettings.graphs);
        //ArrayUtils.deleteItemByKey(item, "id", pageSettings.graphs);
        pageSettings.graphs.splice(indexOf, 0, item);

        /*for (let graphs of pageSettings.graphs) {
            indexOf = direction == "up" ? indexOf - 1 : indexOf + 1;
            ArrayUtils.deleteItem(item, page.graphs);
            //ArrayUtils.deleteItemByKey(item, "id", pageSettings.graphs);
            pageSettings.graphs.splice(indexOf, 0, item);
        }
        this.setState({analyticsSettings:analyticsSettings});*/

        this.state.componentFactory.addDefaultBinding(null, null, pageSettings);
        this.forceUpdate();
        /*this.setState({pageSettings:pageSettings}, function(this:PageSettingsDialog) {
            this.forceUpdate();
        }.bind(this));*/
    }

    renderGraphSetting(item:GraphSettings) {
        let cf = this.state.componentFactory;
        let editFunction = DialogUtil.openFunction(this.graphSettingsDialog.current, item);
        let deleteFunction = () => this.props.dialog.alert("Confirm Delete", "Are you sure you want to delete this graph? This action cannot be undone.", this.deleteGraphSetting.bind(this), item);
        let editDeleteButtons = cf.renderEditDeleteButtons(editFunction,deleteFunction);

        /*const actionLink = [
            <IconButtonComponent icon={BaseIcon.ICON_KEYBOARD_ARROW_UP} tooltip="Move Up" color="primary" onTouchTap={() => this.moveGraph(item, "up")} />,
            <IconButtonComponent icon={BaseIcon.ICON_KEYBOARD_ARROW_DOWN} tooltip="Move Down" color="primary" onTouchTap={() => this.moveGraph(item, "down")} />,
            <IconButtonComponent icon={BaseIcon.ICON_EDIT} tooltip="Edit" color="primary" onTouchTap={DialogUtil.openFunction(this.graphSettingsDialog.current, item)} />,
            <IconButtonComponent icon={BaseIcon.ICON_DELETE} tooltip="Delete" color="secondary" onTouchTap={DialogUtil.openFunction(this.alertDialog.current, item)} />
            ];*/
        const actionLink = [
            cf.renderIconButton(BaseIcon.ICON_KEYBOARD_ARROW_UP, () => this.moveGraph(item, "up"), "Move Up"),
            cf.renderIconButton(BaseIcon.ICON_KEYBOARD_ARROW_DOWN, () => this.moveGraph(item, "down"), "Move Down"),
            editDeleteButtons
        ]

        return [
            item.graphTitle && item.graphTitle != "" ? item.graphTitle : AnalyticsTypes.getLabel(item.dataSource) + " " + AnalyticsTypes.getLabel(item.metric),
            GraphUtil.getChartTypeDescription(item.chartType),
            actionLink
        ]
    }

    public render() {
        let cf = this.state.componentFactory;
        let graphs = cf.getDefaultBinding().getProperty("graphs");
        return cf.renderBox([
            this.state.dialogs,
            cf.renderBoxPadded(cf.renderTextField("pageTitle", "Page Title")),
            cf.renderBoxPadded(cf.renderTextField("pageDescription", "Page Description")),
            cf.renderTableWithNew(["Graph Name", "Chart Type", ""], graphs, this.renderGraphSetting.bind(this), this.graphSettingsDialog)
        ])
    }

    /*ublic render2() {
        let headerRowContentNotification = <ButtonComponent primary={true} title="Add Graph" onTouchTap={DialogUtil.openFunction(this.graphSettingsDialog.current)} />;
        return (
            <Box>
                <AlertDialog ref={this.alertDialog} title="Confirm Delete" message="Are you sure you want to delete this graph? This action cannot be undone." onConfirm={this.deleteGraphSetting.bind(this)} />
                <GraphSettingsDialog ref={this.graphSettingsDialog} title="Settings" actionTitle="Save" actionCallback={this.graphSettingsDialogCallback.bind(this)}/>

                <Box pad><TextComponent id="pageTitle"
                                        fullWidth
                                        type="text"
                                        variant="outlined"
                                        label="Page Title"
                                        value={this.state.pageSettings.pageTitle}
                                        onChange={this.handleChanged.bind(this)}/></Box>

                <Box pad><TextComponent id="pageDescription"
                                        fullWidth
                                        type="text"
                                        variant="outlined"
                                        label="Page Description"
                                        value={this.state.pageSettings.pageDescription}
                                        onChange={this.handleChanged.bind(this)}/></Box>

                <Box pad><TableComponent headers={["Graph Name", "Chart Type", ""]}
                                         headerRowContent={headerRowContentNotification}
                                         uniqueId="id"
                                         rows={this.state.pageSettings.graphs}
                                         fitToContent={true}
                                         getRow={this.renderGraphSetting.bind(this)}/></Box>

            </Box>
        )
    }*/
}

export default dialog(PageSettingsDialog)